<template>
<div id="component">
    <h1 id="title">{{svgtitle}}</h1>
    <div :id="svgId" class="svg-container"></div>
</div>
</template>
<script>

import kazakhstanMap from '../assets/kazakhstanMap';

export default {
  name: 'VenueMapComponent',
  data() {
    return {
      svgtitle: 'Kazakhstan',
      svgId: 'kazakhstanMap',
      mapAttr: {
        viewBoxWidth: !this.isMobile() ? 1106 : 760,
        viewBoxHeight: !this.isMobile() ? 450 : 450,
        imageWidth: !this.isMobile() ? -200 : 0,
        imageHeight: !this.isMobile() ? 0 : 0,
      },
      svgContainer: null,
    };
  },
  mounted() {
    this.generateVenueMap();
  },
  computed: {
    currentLang() {
      return this.$store.state.calc.currentLocale;
    },
  },
  methods: {
    isMobile() {
      if (window.innerWidth <= 760) {
        return true;
      }

      return false;
    },
    generateVenueMap() {
      const vue = this;
      const mapData = kazakhstanMap.g.path;
      const svgContainer = vue.$svg('kazakhstanMap').size('90%', '90%').viewbox(vue.mapAttr.imageWidth, vue.mapAttr.imageHeight, vue.mapAttr.viewBoxWidth, vue.mapAttr.viewBoxHeight);
      vue.svgContainer = svgContainer;
      mapData.forEach((pathObj) => {
        vue.generatePath(svgContainer, pathObj);
      });
    },
    generatePath(svgCont, pathObj) {
      const vue = this;

      const attrs = {
        fill: pathObj['-color'],
        stroke: 'black',
        'stroke-width': 1,
        title: pathObj[this.currentLang],
        ru: pathObj.ru,
        kz: pathObj.kz,
        'map-id': pathObj['-id'],
      };
      const element = svgCont.path(pathObj['-d']).attr(attrs);
      // const text = svgCont.text(pathObj['-title']);
      // const x = element.x();
      // const y = element.y() + 80;

      // text.move(x, y).font({ fill: '#000', family: 'Arial' });
      const self = this;
      // eslint-disable-next-line func-names
      element.mouseover(function () {
        self.svgtitle = this.node.attributes[self.currentLang].value;
      });
      // eslint-disable-next-line func-names
      element.click(function () {
        const mapId = this.node.attributes['map-id'].value;
        const title = this.node.attributes[self.currentLang].value;
        vue.$emit('map-clicked', { mapId, title });
      });
    },
  },

};
</script>

<style scoped>
#title {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #000;
}

#kazakhstanMap:hover{
    cursor: pointer;
}
</style>
